/**
 *
 * @param num a number you want to round
 * @param decimals the decimal places you want to round in 100 means 1.11 & 1000 means 1.111
 * @returns rounded number
 */
export const roundNum = (num: number, decimals: number) => {
  const rounded = Math.round(num * decimals) / decimals;
  return rounded;
};

/**
 * this function rounds in a number in half,
 *
 * if num = `1.2`, the func will return 1.5
 *
 * if num = `1.6` = the func will return 2
 *
 * if num = `1.1` the func will return 1
 * @param num any number
 * @returns rounded number to the next half
 */
export const roundNumToHalf = (num: number) => {
  let roundedDown = Math.floor(num);
  const decimal = roundNum(num % 1, 10);
  if (decimal > 0.5) {
    roundedDown = roundedDown + 1;
  } else if (decimal >= 0.2) {
    roundedDown = roundedDown + 0.5;
  }
  return roundedDown;
};

/**
 * round a number to integer such as:
 * - `1.8877` will be `2`
 * - `1.222` will be `1`
 *
 * @param num any number
 * @returns a whole number
 */
export const roundToInteger = (num: number): number => {
  return Math.round(num);
};

export const convertMilesToKm = (value: number) => {
  return roundToInteger(value * 1.6);
};
export const convertMetersToKm = (value: number) => {
  return Math.round(value / 1000);
};
